export default class TimerUtils {

	static readonly MS_IN_SECONDS: number = 1000

	static readonly SECONDS_IN_MINUTE: number = 60

	static readonly HOURS_IN_DAY: number = 24

	static readonly MINUTE_IN_HOURS: number = TimerUtils.SECONDS_IN_MINUTE

	static readonly MINUTE_IN_DAY: number = TimerUtils.HOURS_IN_DAY * TimerUtils.MINUTE_IN_HOURS

	static readonly MS_IN_MINUTE: number = TimerUtils.SECONDS_IN_MINUTE * TimerUtils.MS_IN_SECONDS

	static readonly SECONDS_IN_DAY: number = TimerUtils.SECONDS_IN_MINUTE * TimerUtils.MINUTE_IN_DAY

	static readonly MS_IN_DAY: number = TimerUtils.SECONDS_IN_DAY * TimerUtils.MS_IN_SECONDS

	static sleep(
		ms: number = TimerUtils.MS_IN_SECONDS
	): Promise<void> {
		return new Promise(resolve => setTimeout(resolve, ms));
	}

}